import { __assign } from "tslib";
import * as React from 'react';
import { renderAndMountComponent } from '@wix/answers-lib';
import { Modal } from './modal';
import { jsdomReactUniDriver } from '@unidriver/jsdom-react';
export * from './modal-header/modal-header.driver';
export var createModalDriver = function (wrapper) {
    var base = wrapper.$('.modal');
    return {
        clickOverlay: function () { return base.$('.modal-overlay').click(); },
        clickCloseButton: function () { return base.$('.close-btn').click(); },
        hasBodyCloseButton: function () { return base.$('.modal-body .close-button-container .close-btn').exists(); },
        hasHeaderCloseButton: function () { return base.$('.modal-header .close-btn').exists(); },
        base: base
    };
};
export var createModal = function (props, modalHeader, modalBody, modalFooter) {
    var elem = renderAndMountComponent(React.createElement(Modal, __assign({}, props),
        modalHeader,
        modalBody,
        modalFooter));
    return createModalDriver(jsdomReactUniDriver(elem));
};
//# sourceMappingURL=driver.js.map